/* eslint-disable import/prefer-default-export */

// This file is used to define any default values that are used in the application.

export const defaultColumnLayout = [
	{ field: 'groupKeyDisplayName', visible: true },
	// purchased
	{ field: 'description', visible: true },
	{ field: 'qtyPurchased', visible: true },
	{ field: 'unit', visible: false },
	{ field: 'packSize', visible: true },
	{ field: 'pricePerCase', visible: true },
	{ field: 'caseVolume', visible: true },
	{ field: 'manufacturerName', visible: true },
	{ field: 'brandName', visible: false },
	{ field: 'brandType', visible: false },
	{ field: 'mpc', visible: false },
	{ field: 'dpc', visible: false },
	{ field: 'internalCategoryName', visible: false },
	{ field: 'distributorParentName', visible: false },
	{ field: 'distributorLocationName', visible: false },
	{ field: 'currentProgramType', visible: false },
	{ field: 'exclusionSource', visible: false },
	{ field: 'switchLikelihood', visible: true },
	// misc
	{ field: 'packCvtModified', visible: true },
	{ field: 'basket', visible: true },
	{ field: 'type', visible: true },
	{ field: 'hasSimilarProducts', visible: true },
	// matched
	{ field: 'matchedRecommendationScore', visible: true },
	{ field: 'matchedScore', visible: true },
	{ field: 'matchedExclusionSource', visible: false },
	{ field: 'matchedDescription', visible: true },
	{ field: 'matchedQty', visible: false },
	{ field: 'matchedPackSizeConversion', visible: true },
	{ field: 'matchedUnit', visible: false },
	{ field: 'matchedPackSize', visible: true },
	{ field: 'matchedDeviatedPrice', visible: true },
	{ field: 'matchedVolume', visible: false },
	{ field: 'matchedDateRangeContractSavings', visible: false },
	{ field: 'matchedDateRangeRebateSavings', visible: false },
	{ field: 'matchedDateRangeTotalSavings', visible: false },
	{ field: 'matchedAnnualPriceSavings', visible: true },
	{ field: 'matchedAnnualRebate', visible: true },
	{ field: 'matchedAnnualTotalSavings', visible: true },
	{ field: 'matchedSavingsPercentage', visible: true },
	{ field: 'matchedStocked', visible: true },
	{ field: 'matchedManufacturerName', visible: true },
	{ field: 'matchedBrand', visible: false },
	{ field: 'matchedBrandOwner', visible: false },
	{ field: 'matchedCategory', visible: false },
	{ field: 'matchedMpc', visible: false },
	{ field: 'matchedDpc', visible: false },
	{ field: 'matchedDeviatedCost', visible: false },
	{ field: 'matchedAdjustedDeviatedCost', visible: false },
	{ field: 'matchedPerCaseSavings', visible: false },
	{ field: 'matchedSavingsTermSetName', visible: true },
	{ field: 'matchedRebateTermSetName', visible: false },
]

// Default values for user preferences. The api does not store defaults,
// so we need to define them here and apply them to a user.
export const userPreferenceDefaults = [
	{ key: 'reportsOnlyFavorites', value: false },
	{ key: 'reportsCombinePersonalized', value: false },
	{ key: 'sidebarExpanded', value: true },
	{ key: 'showMyBaskets', value: false },
	{
		key: 'purchaseListColumns',
		value: defaultColumnLayout,
	},
	{ key: 'purchaseColumnLayout', value: null },
]
